import request from '@/utils/request'

// 工单交期调整报表查询列表
export function apiGetAssessmentDeliveryDateChanges(query) {
  return request({
    url: '/inv/invMesAssessmentDeliveryDateChange/getAssessmentDeliveryDateChanges',
    method: 'get',
    params: query
  })
}

// 导出工单交期调整报表
export function apiAssessmentDeliveryDateChangesExport (data) {
  return request({
    url: `/inv/invMesAssessmentDeliveryDateChange/v2/assessmentDeliveryDateChangesExport`,
    method: 'post',
    data: data
  })
}
